module.exports = __webpack_public_path__ + "static/logo-prte-3993cdcc7fdea73b422ddc531d4c6183.png";